<!-- src/components/LoginPromptModal.svelte -->
<script>
  import { authStore } from '../authStore';
  import { login } from '../authService';
  import { navigate } from 'svelte-routing';

  export let redirectPath = '/login';

  async function handleLogin() {
    authStore.dismissLoginPrompt();
    if (typeof login === 'function') {
      try {
        await login();
        return;
      } catch (err) {
        console.warn('Login invocation failed, falling back to route navigation:', err);
      }
    }
    if (redirectPath) {
      navigate(redirectPath);
    }
  }

  function handleDismiss() {
    authStore.dismissLoginPrompt();
  }
</script>

{#if $authStore.showLoginPrompt}
  <div class="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="modal-title">
    <div class="modal-card">
      <div class="modal-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#e02424" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>

      <h2 id="modal-title">Session Expired</h2>
      <p class="modal-description">
        Your security session has expired. Please log in again to continue accessing your account.
      </p>

      <div class="modal-actions">
        <button class="btn btn-secondary" on:click={handleDismiss}>Dismiss</button>
        <button class="btn btn-primary" on:click={handleLogin}>Log In</button>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    backdrop-filter: blur(3px);
  }

  .modal-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 2rem;
    max-width: 420px;
    width: 90%;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    text-align: center;
    animation: fadeIn 0.2s ease-out;
  }

  .modal-icon {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }

  h2 {
    margin: 0 0 0.5rem 0;
    font-size: 1.4rem;
    color: #1a202c;
  }

  .modal-description {
    color: #4a5568;
    font-size: 0.95rem;
    line-height: 1.5;
    margin-bottom: 1.5rem;
  }

  .modal-actions {
    display: flex;
    justify-content: center;
    gap: 0.75rem;
  }

  .btn {
    padding: 0.65rem 1.4rem;
    border-radius: 6px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: background-color 0.2s, transform 0.1s;
  }

  .btn:active {
    transform: scale(0.98);
  }

  .btn-primary {
    background-color: #007bff;
    color: #ffffff;
  }

  .btn-primary:hover {
    background-color: #0056b3;
  }

  .btn-secondary {
    background-color: #e2e8f0;
    color: #4a5568;
  }

  .btn-secondary:hover {
    background-color: #cbd5e1;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
